export function getDepositList(data) {
    let { getDepositListRequest, getDepositListError, getDepositListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/deposit/list',
        this.createBundle('app/deposit/list', { deposit: data }, this.GET, getDepositListRequest, getDepositListResult, getDepositListError)
    )
}
